import { shareContent } from "@/utils/shareProduct.js";

export function buildOrderShareUrl(orderId) {
    if (typeof window === "undefined" || orderId == null) {
        return "";
    }
    const base = window.location.origin.replace(/\/$/, "");
    return `${base}/orders/${orderId}`;
}

/**
 * e.g. "Ordre du 10 Novembre 2025 à 13h45" (Africa/Douala, minutes precision).
 */
export function formatOrderShareTitle(isoDate) {
    if (!isoDate) {
        return "Ordre";
    }
    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) {
        return "Ordre";
    }
    const datePart = date.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "Africa/Douala"
    });
    const match = datePart.match(/^(\d{1,2})\s+(\S+)\s+(\d{4})$/);
    const niceDate = match
        ? `${match[1]} ${match[2].charAt(0).toUpperCase()}${match[2].slice(1)} ${match[3]}`
        : datePart;
    const timePart = date.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Africa/Douala"
    });
    const niceTime = timePart.replace(":", "h").replace(/\s/g, "");
    return `Ordre du ${niceDate} à ${niceTime}`;
}

/**
 * @returns {"shared"|"copied"|"cancelled"}
 */
export async function shareOrder({ orderId, orderDate }) {
    return shareContent({
        title: formatOrderShareTitle(orderDate),
        url: buildOrderShareUrl(orderId)
    });
}
